<template>
  <div class="price-manager">
    <common-button
      v-if="hasControls && hasPrices"
      class="uk-margin"
      icon="plus"
      :disabled="disabled"
      @click="newPrice"
    >
      {{$t('actions.addPrice')}}
    </common-button>

    <price-form
      ref="formModal"
      title="Preis verwalten"
      :prices="prices"
      :values="editedPrice"
      @submit="submitPrice"
      @hidden="resetEditedPrice"
    />

    <price-table
      v-if="hasPrices"
      :prices="prices"
      :show-actions="showTableActions"
      @edit="editPrice"
      @remove="removePrice"
    />

    <div v-else class="uk-placeholder uk-margin-remove-top uk-text-center">
      <div>
        <icon name="warning" />
        {{$t('hints.noPrices')}}
      </div>

      <common-button
        v-if="hasControls"
        class="uk-margin"
        icon="plus"
        :disabled="disabled"
        @click="newPrice"
      >
        {{$t('actions.addPrice')}}
      </common-button>
    </div>
  </div>
</template>

<script>
import { cloneDeep, sortBy } from 'lodash';
import CommonButton from '@/components/CommonButton';
import DataGridActions from '@/components/DataGridActions';
import Price from '@/components/Price';
import PriceForm from '@/components/PriceForm';
import PriceTable from '@/components/PriceTable';
import TextPlaceholder from '@/components/TextPlaceholder';

export default {
  name: 'price-manager',
  components: {
    CommonButton,
    DataGridActions,
    Price,
    PriceForm,
    PriceTable,
    TextPlaceholder,
  },
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    disabled: Boolean,
    hasControls: {
      type: Boolean,
      default: true,
    },
  },
  watch: {
    value(value) {
      this.prices = cloneDeep(value || []);
    },
  },
  data() {
    return {
      prices: cloneDeep(this.value || []),
      editedPriceIndex: null,
    };
  },
  computed: {
    hasPrices() {
      return this.prices.length > 0;
    },
    editedPrice() {
      if (this.editedPriceIndex === null) return null;
      return this.prices[this.editedPriceIndex];
    },
    showTableActions() {
      return this.hasControls && !this.disabled;
    },
  },
  methods: {
    newPrice() {
      this.resetEditedPrice();
      this.$refs.formModal.show();
    },
    editPrice(index) {
      this.editedPriceIndex = index;
      this.$refs.formModal.show();
    },
    submitPrice(price) {
      const { prices } = this;
      if (this.editedPriceIndex === null) {
        prices.push(price);
      } else {
        prices[this.editedPriceIndex] = price;
      }
      this.prices = sortBy(prices, p => p.value);
      this.$refs.formModal.hide();
      this.onInput();
    },
    removePrice(index) {
      this.prices.splice(index, 1);
      this.onInput();
    },
    resetEditedPrice() {
      this.editedPriceIndex = null;
    },
    onInput() {
      this.$emit('input', this.prices);
      this.$emit('change', this.prices);
    },
  },
  i18n: {
    messages: {
      de: {
        actions: {
          addPrice: 'Preis hinzufügen',
        },
        fields: {
          organization: 'VO',
          paymentFrequency: 'Zahlungsintervall',
          value: 'Preis',
        },
        hints: {
          noPrices: `Für dieses Angebot sind aktuell noch keine Preise
                     hinterlegt. Angebote ohne Preise sind nicht sichtbar.`,
        },
      },
    },
  },
};
</script>



// WEBPACK FOOTER //
// PriceManager.vue?23178f56